<p class="d-flex cursor-pointer artifact-name" 
    (click)="_ui.expandedArtifactId.next(artifact.artifactId);" 
    [ngClass]="{
        'artifact-selected':_ui.expandedArtifactId.value == artifact.artifactId, 
        'artifact-submit':[ARTIFACT_STATUS.SUBMIT].includes(artifact.artifactStatus),
        'artifact-complete':[ARTIFACT_STATUS.PACKAGECOMPLETE,ARTIFACT_STATUS.COMPLETE].includes(artifact.artifactStatus)
    }">
    <mat-icon class="icon-round check-icon d-none">check</mat-icon>
    <mat-icon class="icon-round selected-icon d-none">chevron_right</mat-icon>
    <mat-icon class="empty-icon">khalibox</mat-icon>
    <span class="mx-2">{{artifact.name || artifact.type}}</span>
    <mat-icon *ngIf="appWizService.isReadOnly(artifact)">edit_off</mat-icon>
</p>